import React from 'react'
import SubCatIcons from '../subCategoryCard/subCategoryCard.jsx'

const SubCategoryCardList = (props) => {
    const {
        showMoreData, 
        selectedData, 
        getData, 
        getById, 
        cat1, 
        feature, 
        setShowMore,
        heading, 
        subHeading
    } = props;

    return (
        <section className="whatareyou">
            <div className="container">
                <h2>{heading} <span>{subHeading}</span></h2>
                <div className={`whatareyoucat ${showMoreData ? 'showEnable' : ''}`}>
                    <div 
                        className={`whatarecatbox what-res ${selectedData === 0 ? 'active' : ''}`} 
                        onClick={() => getData()}
                    >
                        <img src={cat1} alt="icons" />
                        <p className="hover-none">All</p>
                    </div>
                    {feature?.map((data, index) => (
                        <SubCatIcons
                            key={data?.id || data?.name || index}
                            iconsData={data}
                            selectedData={selectedData}
                            getById={getById}
                        />
                    ))}
                </div>
                <div 
                    className="d-block d-sm-none smmore" 
                    onClick={(e) => { setShowMore(!showMoreData) }}
                >
                    {showMoreData ? 'Show Less...' : 'Show More...'} 
                </div>
            </div>
        </section>
    );
};

export default SubCategoryCardList;